<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'orderNo')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.ORDER + 'orderNo'))"
                       v-model='queryParam.orderNo'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.CUSTOMER + 'custName')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.CUSTOMER + 'custName'))"
                       v-model='queryParam.aadhaarName'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <!--     审核状态-->
            <a-form-item :label="$t(I18N_KEY.ORDER + 'approvalStatus')">
              <dict-select
                v-model='queryParam.approvalStatus'
                :dict-code='DICT_CODE.ORDER_STATUS'
                :begin="[{ value: '', label: '全部', labelEn: 'All',labelTi: 'ทั้งหมด' }]"
                :placeholder="$t('select')"
              />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <!--     结清状态-->
            <a-form-item :label="$t(I18N_KEY.ORDER + 'settleStatus')">
              <dict-select
                v-model='queryParam.settleStatus'
                :dict-code='DICT_CODE.SETTLE_STATUS'
                :begin="[{ value: '', label: '全部', labelEn: 'All',labelTi: 'ทั้งหมด' }]"
                :placeholder="$t('select')"
              />
            </a-form-item>
          </a-col>
          <template v-if='toggleSearchStatus'>
            <a-col :md='12' :sm='12'>
              <a-form-item :label="$t(I18N_KEY.ORDER + 'approvalTime')">
                <a-range-picker
                  v-model='queryParam.approvalcreatedTime'
                  format='YYYY-MM-DD'
                  style='width: 100%;' />
              </a-form-item>
            </a-col>
            <a-col :md='12' :sm='12'>
              <a-form-item :label="$t(I18N_KEY.APPROVAL + 'TaskSubTime')">
                <a-range-picker
                  v-model='queryParam.createdTime'
                  format='YYYY-MM-DD'
                  style='width: 100%;' />
              </a-form-item>
            </a-col>
            <a-col :md='6' :sm='8'>
              <a-form-item :label="$t(I18N_KEY.APPROVAL + 'examinerName')">
                <a-select @change='examinePeopleChange' v-model='queryParam.examinerId' style='width: 100%;'>
                  <a-select-option
                    v-for='item in ExamineUser'
                    :key='item.userId'
                    :value='item.userId'>
                    {{ item.userName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
               <a @click='handleToggleSearch' style='margin-left: 8px'>
                     {{ $t(toggleSearchStatus ? 'hide' : 'show') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-button style='margin-bottom: 20px;' type='primary' @click='openBatchDialog' :disabled='!selectedList.length'
                icon='plus'>{{ $t(I18N_KEY.COLLECTION + 'batchReplacementFollowStaff') }}
      </a-button>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        :rowSelection='{ onChange: selectRowsChange, selectedRowKeys }'
        bordered>
        <Dict slot='approvalStatus' slot-scope='text' :dict-code='DICT_CODE.ORDER_STATUS' :value='text' />
        <Dict slot='settleStatus' slot-scope='text' :dict-code='DICT_CODE.SETTLE_STATUS' :value='text' />
        <Dict slot='approvalTaskStatus' slot-scope='text' :dict-code='DICT_CODE.APPROVAL_TASK_STATUS' :value='text' />

        <span slot='action' slot-scope='text, record'>
            <a @click='handleDetail(record)'>{{ $t('view') }}</a>
            <a-divider type='vertical' />
            <a
              v-if="record.approvalTaskStatus == '0'||record.approvalTaskStatus == '1'||record.approvalTaskStatus == '2'"
              @click='handleUser(record)'>{{ $t(I18N_KEY.APPROVAL + 'invoke') }}</a>
        </span>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>
    <v-modal
      v-model='visible'
      :title="$t('order.approvalDetail')">
      <div style='padding: 20px;'>
        <approval-detail
          v-if='visible'
          :orderId='orderId'
          :custInfoId='custInfoId'
          :taskId='taskId'
          :phoneprops='phoneprops'
          :approvalStatus='approvalStatus'
          v-on:searchQuery='searchQuery'
          v-on:closeDetail='closeDetail'
          @close='closeDetail' />
      </div>
    </v-modal>
    <a-modal
      v-model='visibleT'
      :title="$t(I18N_KEY.COLLECTION + 'transferOrder')"
      @ok='handleOk'
      :confirmLoading='confirmLoading'
      @cancel='handleCancel'
    >
      <a-radio-group @change='onChange' v-model='selectUser'>
        <a-radio v-for='(item) in ExamineUser' :key='item.userId' :style='radioStyle' :value='item.userId'>
          {{ item.userName }}
        </a-radio>
      </a-radio-group>
    </a-modal>
    <a-modal
      v-model='batchVisible'
      :title='$t(I18N_KEY.COLLECTION)'
      :confirmLoading='confirmLoading'
      :width='700'
      @ok='submitBatch'
      @cancel='closeBatchDialog'
    >
      <div>
        <div>
          <p class='description d_title'>{{ $t('platformCollection.instructions_for_filling_in') }}</p>
          <p class='description d_text'>{{ $t('platformCollection.instructions_for_filling_in_1') }}</p>
          <p class='description d_text'>{{ $t('platformCollection.instructions_for_filling_in_2') }}</p>
        </div>
        <p class='description d_high_light'>{{ $t('platformCollection.total_order_quantity_checked')
          }}{{ selectedList.length }}</p>
        <a-table
          ref='table'
          rowKey='id'
          size='middle'
          :columns='batchColumns'
          :dataSource='batchList'
          :pagination='false'
          :loading='batchLoading'
          bordered>
            <span slot='action' slot-scope='text, record'>
                <a-input v-model='record.taskNum' />
            </span>
        </a-table>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getAllTask, getExamineUser, modExamineTaskUser } from '@/webpublicapi/approval'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import vModal from '../modules/Modal'
import ApprovalDetail from './ApprovalDetail'
import { mapActions, mapGetters } from 'vuex'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.',
  COLLECTION: 'collection.'
}

export default {
  name: 'AllApprovalTask',
  components: {
    Dict,
    DictSelect,
    vModal,
    ApprovalDetail
  },
  data() {
    return {
      phoneprops:null,
      mobileNo: null,
      I18N_KEY,
      toggleSearchStatus: false,
      confirmLoading: false,
      visible: false,
      visibleT: false,
      orderId: undefined,
      custInfoId: undefined,
      // taskId: undefined,
      batchVisible: false,
      batchLoading: false,
      selectedRowKeys: [],
      approvalStatus: undefined,
      settleStatus: undefined,
      selectedList: [],
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      // 查询条件
      queryParam: {
        'orderNo': '',
        'approvalStatus': '',
        'settleStatus': '',
        'aadhaarName': '',
        'applyAmtMin': '',
        'applyAmtMax': '',
        'applyDate': undefined,
        'examinerId': undefined
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      },
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      selectUser: '',
      ExamineUser: [],
      taskId: ''
    }
  },
  computed: {
    ...mapGetters('approval', ['listUserWithNum']),
    batchList() {
      return this.listUserWithNum || []
    },
    columns() {
      return [
        {
          title: this.$t('order.orderNo'),
          align: 'left',
          dataIndex: 'orderNo'
        },
        {
          title: this.$t('customer.custName'),
          align: 'left',
          dataIndex: 'aadhaarName'
        },
        {
          title: this.$t('order.applicationAmount'),
          align: 'left',
          dataIndex: 'applyAmt'
        },
        {
          title: this.$t('order.applicationDeadline'),
          align: 'left',
          dataIndex: 'duration'
        },
        {
          title: this.$t('approval.TaskSubTime'),
          align: 'left',
          dataIndex: 'shareOrderTime' //createTime
        },
        {
          title: this.$t('order.approvalStatus'),
          align: 'left',
          dataIndex: 'approvalStatus',
          scopedSlots: { customRender: 'approvalStatus' }
        },
        {
          title: this.$t('order.approvalTaskStatus'),
          align: 'left',
          dataIndex: 'approvalTaskStatus',
          scopedSlots: { customRender: 'approvalTaskStatus' }
        },
        {
          title: this.$t('order.approvalStaff'),
          align: 'left',
          dataIndex: 'examinerName'
        },
        {
          title: this.$t('order.approvalTime'),
          align: 'left',
          dataIndex: 'examineTime'
        },
        {
          title: this.$t('order.settleStatus'),
          align: 'left',
          dataIndex: 'settleStatus',
          scopedSlots: { customRender: 'settleStatus' }
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    batchColumns() {
      return [
        {
          title: this.$t('name'),
          align: 'left',
          dataIndex: 'userName'
        },
        {
          title: this.$t('order.followingUpOrder'),
          align: 'left',
          dataIndex: 'undoNum'
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    console.log('queryParam.approvalStatus------->>', this.queryParam.approvalStatus)
    this.getDict()
    this.loadData(1)
    getExamineUser().then((res) => {
      if (res.code === 1000) {
        this.ExamineUser = res.data
      } else {
        this.ExamineUser = []
        this.$message.error(res.msg)
      }
    }).catch(e => {
      this.$message.error(e.message)
    })
  },
  methods: {
    examinePeopleChange(val) {
      console.log('切换了审批人val-->', val)
    },
    ...mapActions('approval', ['getListUserWithNum', 'batchChangeUser']),
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 清空选中项
      this.selectedList = []
      this.selectedRowKeys = []
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      console.log('准备查询的参数--->>>', params)
      getAllTask(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      console.log('this.queryParam', this.queryParam)
      const data = {
        ...this.queryParam
      }
      const searchparam = Object.assign({}, data)
      if (this.queryParam.createdTime) {
        if (this.queryParam.createdTime.length) {
          console.log('选择了分单日期')
          const starttime = this.queryParam.createdTime[0]._d
          const endtime = this.queryParam.createdTime[1]._d
          const startDate1 = new Date(starttime).toISOString().split('T')[0]
          const endtime2 = new Date(endtime).toISOString().split('T')[0]
          searchparam.applyDateStart = startDate1
          searchparam.applyDateEnd = endtime2
        }
      }
      if (this.queryParam.approvalcreatedTime) {
        if (this.queryParam.approvalcreatedTime.length) {
          console.log('选择了审批日期')
          const starttime = this.queryParam.approvalcreatedTime[0]._d
          const endtime = this.queryParam.approvalcreatedTime[1]._d
          const startDate1 = new Date(starttime).toISOString().split('T')[0]
          const endtime2 = new Date(endtime).toISOString().split('T')[0]
          searchparam.approvalDateStart = startDate1
          searchparam.approvalDateEnd = endtime2
        }

      }
      searchparam.pageNum = this.form.pageNum
      searchparam.pageSize = this.form.pageSize
      console.log('searchparam', searchparam)
      return searchparam
    },
    handleTableChange(pageNum, pageSize) {
      console.log(1111)
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.orderNo = ''
      that.queryParam.approvalStatus = ''
      that.queryParam.settleStatus = ''
      that.queryParam.aadhaarName = ''
      that.queryParam.applyDate = undefined
      that.queryParam.examinerId = undefined
      that.queryParam.createdTime = ''
      that.queryParam.approvalcreatedTime = ''
      that.queryParam.approvalDate=undefined
      that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      console.log('visible-->', visible)
      this.visible = visible
    },
    handleDetail(row) {
      console.log('完整row数据：', JSON.stringify(row)); // 查看是否有 mobileNo
      // console.log('row烦死-->', row.mobileNo)
      this.phoneprops = row.mobileNo
      this.orderId = row.orderId
      this.custInfoId = row.custInfoId
      this.taskId = row.taskId
      this.changeModal(true)
      this.approvalStatus = row.approvalStatus
      console.log('row', row)
    },
    closeDetail() {
      console.log('123123')
      this.visible = false
    },
    handleUser(row) {
      this.selectUser = ''
      this.taskId = row.taskId
      this.confirmLoading = true
      if (this.ExamineUser.length == 0) {
        getExamineUser().then((res) => {
          if (res.code === 1000) {
            this.ExamineUser = res.data
          } else {
            this.ExamineUser = []
            this.$message.error(res.msg)
          }
          this.confirmLoading = false
        }).catch(e => {
          this.confirmLoading = false
          this.$message.error(e.message)
        })
      } else {
        this.confirmLoading = false
      }
      this.visibleT = true
    },
    onChange(e) {
      this.selectUser = e.target.value
    },
    selectRowsChange(selectedRowKeys, selectedRows) {
      console.log('selectedRowKeys', selectedRowKeys)
      console.log('selectedRows', selectedRows)
      // this.selectedRowKeys = selectedRowKeys
      // this.originSelectedList = selectedRows
      // this.selectedList = _.cloneDeep(selectedRows)
      console.log('selectedRows[0].approvalTaskStatus', selectedRows[selectedRows.length - 1].approvalTaskStatus)
      if (selectedRows[selectedRows.length - 1].approvalTaskStatus == 3) {
        console.log('状态是process')
        this.$message.error('Approval task status is Processed, check failed!')
      } else {
        this.selectedRowKeys = selectedRowKeys
        this.originSelectedList = selectedRows
        this.selectedList = _.cloneDeep(selectedRows)
      }
    },
    openBatchDialog() {
      this.batchVisible = true
      this.batchLoading = true
      this.selectedList.length && this.getListUserWithNum().finally(res => {
        this.batchLoading = false
      })
    },
    closeBatchDialog() {
      this.batchVisible = false
      this.selectedList = _.cloneDeep(this.originSelectedList || [])
    },
    submitBatch() {
      const taskIds = this.selectedList.map(t => t.taskId)
      const userTask = this.batchList.map(t => ({ userId: t.userId, taskNum: t.taskNum ? +t.taskNum : 0 }))
      const totalNum = userTask.map(t => t.taskNum).reduce((total, num) => (total += num), 0)
      console.log(userTask, totalNum)
      if (!userTask.length) {
        return this.closeBatchDialog()
      }
      if (isNaN(totalNum)) {
        return this.$message.error(this.$t('please_enter_a_positive_integer'))
      }
      if (totalNum > this.selectedList.length) {
        return this.$message.error(this.$t('platformCollection.cannot_be_greater_than_the_total_quantity_of_the_checked_order'))
      }
      this.closeBatchDialog()
      this.loading = true
      this.batchChangeUser({ taskIds, userTask }).then(res => {
        this.loadData()
        this.$message.success(this.$t('success'))
      }).finally(res => {
        this.loading = false
      })
    },
    handleOk(e) {
      if (this.selectUser != '') {
        this.confirmLoading = true
        modExamineTaskUser({ userId: this.selectUser, taskId: this.taskId }).then((res) => {
          if (res.code === 1000) {
            this.visibleT = false
            this.confirmLoading = false
            this.loadData()
          } else {
            this.confirmLoading = false
            this.$message.error(res.msg)
          }
        }).catch(e => {
          this.confirmLoading = false
          this.$message.error(e.message)
        })
      } else {
        this.$message.error('请选择跟进人!')
      }
    },
    handleCancel(e) {
      this.visibleT = false
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
